import { Alert, AlertProps, Box, Button, Grid, TextField } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { Attendance_Service } from "../../services/attendance/attendance-service";
import { Autocomplete } from "../Autocomplete/Autocomplete";
import UserContext, { User_Type } from "../UserContext";

const initialFeedback: {
    message: string;
    loading: boolean;
    show: boolean;
    severity?: AlertProps["severity"];
} = {
    message: "",
    loading: false,
    show: false,
    severity: undefined,
};

const SingleUserSync = () => {
    const [pin, setPin] = useState("");
    const [loading, setLoading] = useState(false);
    const [feedback, setFeedback] = useState(initialFeedback);
    const [organizationCode, setOrganizationCode] = useState("");
    const [serialNo, setSerialNo] = useState("");
    const [apiKey, setApiKey] = useState("");
    const { user } = useContext(UserContext);

    async function sync_device_attendance(event: any) {
        event.preventDefault();
        setLoading(true);

        try {
            const [data, error] =
                await Attendance_Service.sync_device_attendance(
                    serialNo,
                    organizationCode,
                    pin
                );

            if (error) {
                setFeedback({
                    loading: false,
                    show: true,
                    message: error.message,
                    severity: "error",
                });
            } else {
                setFeedback({
                    loading: false,
                    show: true,
                    message: data?.message || "User synced successfully",
                    severity: "success",
                });
            }
        } catch (err: any) {
            console.error(err);
            setFeedback({
                loading: false,
                show: true,
                message: err.message || "Something went wrong",
                severity: "error",
            });
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (user?.user_type === User_Type.Admin) {
            setOrganizationCode(user?.organization?.code);
            setApiKey(user?.organization?.apiKey[0].key);
        }
    }, [user?.user_type]);

    return (
        <Box display="flex" flexDirection="column" gap={2} mb={2}>
            {feedback.show && (
                <Alert
                    severity={feedback.severity}
                    onClose={() => setFeedback(initialFeedback)}
                >
                    {feedback.message}
                </Alert>
            )}

            <form onSubmit={sync_device_attendance}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <TextField
                            label="Pin"
                            fullWidth
                            name="pin"
                            value={pin}
                            onChange={(event: any) =>
                                setPin(event.target.value)
                            }
                            required
                        />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Autocomplete
                            key={`device-input`}
                            label="Device"
                            labelKey="name"
                            setOutput={(d) => setSerialNo(d?.serial ?? "")}
                            api="/device"
                            apiParams={{
                                organization: organizationCode,
                            }}
                            request_headers={{
                                "x-org": organizationCode,
                                authorization: `Bearer ${apiKey}`,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Button
                            sx={{ mr: "auto", width: "100%", height: "100%" }}
                            type="submit"
                            variant="contained"
                            disabled={loading}
                        >
                            {loading ? "Syncing..." : "Sync Single User"}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
};

export default SingleUserSync;
